import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { stationsGridMapOpenAtom, TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";
import { deepPurpleMui, greyMui } from "@ryde/theme";

import { MapToggleButtonStyled } from "./elements.styled";

export const StationsMapToggleButton: FC = () => {
  const { t } = useTranslation();
  const [isMapOpen, setIsMapOpen] = useRecoilState(stationsGridMapOpenAtom);

  const onMapToggle = useEvent((): void => {
    setIsMapOpen(prev => !prev);
  });

  const mapColor = isMapOpen ? deepPurpleMui.A700 : greyMui._600;

  return (
    <FramerTooltip
      content={t("ui.TOGGLE_MAP")}
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <MapToggleButtonStyled onClick={onMapToggle}>
        <SVG_MUI.MapToggle4SVG fill={mapColor} className="MapToggleButtonSVG" />
        <label style={{ color: mapColor }}>{t("ui.MAP")}</label>
      </MapToggleButtonStyled>
    </FramerTooltip>
  );
};
